var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    {
      staticClass: "game-pane",
      class: [
        `game-pane--${_vm.product}`,
        { "game-pane--wide": _vm.wide, "game-pane--focused": _vm.focused },
      ],
    },
    [
      _vm.$slots.title
        ? _c(
            "header",
            { staticClass: "game-pane__title" },
            [_vm._t("title")],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "game-pane__main" }, [
        _c("div", { staticClass: "game-pane__video" }, [_vm._t("video")], 2),
        _vm.$slots.info
          ? _c("div", { staticClass: "game-pane__info" }, [_vm._t("info")], 2)
          : _vm._e(),
        _vm.wide && _vm.$slots.aside
          ? _c("div", { staticClass: "game-pane__aside" }, [_vm._t("aside")], 2)
          : _vm._e(),
        _vm.$slots.selector
          ? _c(
              "div",
              { staticClass: "game-pane__selector" },
              [_vm._t("selector")],
              2
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "game-pane__body" }, [_vm._t("default")], 2),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }